import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'count': 0,
  'list': [],
  'limit': 20,
  'offset': 0,
  'downloading': false,
  'priceFactorsListUrl': '',
};

export const priceFactorsList = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.GET_PRICE_FACTORS_INFO_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_PRICE_FACTORS_INFO_SUCCESS]: (state, action) => ({
      ...state,
      'count': action.response.count,
      'list': action.response.data,
      'loading': false,
    }),
    [ActionTypes.GET_PRICE_FACTORS_INFO_FAILED]: (state, action) => ({
      ...state,
      'count': 0,
      'list': [],
      'loading': false,
    }),
    [ActionTypes.CLEAR_PRICE_FACTORS_LIST]: (state, action) => ({
      ...state,
      ...INITIAL_STATE,
    }),
    [ActionTypes.CHANGE_PRICE_FACTORS_PAGE]: (state, action) => ({
      ...state,
      'offset': action.payload,
    }),
    [ActionTypes.CHANGE_PRICE_FACTORS_PAGE_SIZE]: (state, aciton) => ({
      ...state,
      'limit': aciton.payload,
    }),
    [ActionTypes.DOWNLOAD_PRICE_FACTOR_LIST_REQUEST]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOAD_PRICE_FACTOR_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'downloading': false,
      'priceFactorsListUrl': action.response.data,
    }),
    [ActionTypes.CLEAR_PRICE_FACTORS_LIST_URL]: (state, action) => ({
      ...state,
      'priceFactorsListUrl': '',
    }),
  })(state, action);
};
